import { combinedColor, GRAY_LIGHT_2, OPACITY_MEDIUM } from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

export const LocationEditSideSectionStyles = makeStyles(() => ({
  LocationEditSideSectionContainer: {
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    WebkitHyphens: 'auto',
    MsHyphens: 'auto',
    hyphens: 'auto',
    paddingBottom: 25,
    width: '100%',
    color: '#4a4d51',
    fontSize: 13,
    WebkitFontSmoothing: 'antialiased!important',
  },
  LocationEditSideSectionCarasoul: {
    height: 114,
    background: '#e1e1e1',

    '&>ul': {
      bottom: -2,
      '&>li': {
        width: 0,
        '&>button': {
          width: 0,
          '&:before': {
            width: 10,
            color: '#adadad',
          },
        },
      },
      '&>li.slick-active': {
        '&>button': {
          '&:before': {
            color: 'white',
          },
        },
      },
    },
  },
  LocationEditSideSectionCarasoulContainer: {
    position: 'absolute',
    boxShadow: 'inset 0px 0px 30px #505050',
    top: 0,
    height: 115,
    width: '100%',
    zIndex: 2,
  },
  LocationEditSideSectionCarasoulItem: {
    width: '100%',
    height: 114,
    objectFit: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    color: 'transparent',
  },
  LocationEditSideSectionTitle: {
    margin: '0 7px',
    padding: '10px 0 11.5px',
    fontSize: 14,
    lineHeight: '13.5px',
    color: combinedColor(GRAY_LIGHT_2, OPACITY_MEDIUM),
    borderBottom: '2px solid #ededed',
  },
  LocationEditSideSectionSection: {
    margin: '17.5px 7px 15px',
    paddingBottom: 15,
    borderBottom: '2px solid #ededed',
  },
  LocationEditSideSectionSectionTitle: {
    margin: '0 0 15.5px',
    padding: 0,
    fontSize: 12,
    lineHeight: '6.7px',
    color: combinedColor(GRAY_LIGHT_2, OPACITY_MEDIUM),
  },
  LocationEditSideSectionSectionDescription: {
    fontSize: 10,
    lineHeight: '13px',
    margin: 0,
    whiteSpace: 'pre-line',
  },
  LocationEditSideSectionSectionOpeningHours: {
    fontSize: 10,
    lineHeight: '13px',
    margin: '0 0 15.5px',
  },
  LocationEditSideSectionHref: {
    color: '#337be2',
    fontSize: 12,
    textDecoration: 'none',
    transition: 'color .2s',
  },
  LocationEditSideSectionButton: {
    margin: '0 7px',
    width: 'calc(100% - 14px)',
    height: 30,
    color: 'white',
    background: '#337be2',
    border: 0,
    borderRadius: 2,
    fontSize: 9,
  },
  LocationEditSideSectionL: {
    width: 10,
    height: 10,
    position: 'absolute',
    top: 124,
    right: 18,
    border: '1px solid #d9d9d9',
    color: '#337be2',
    fontSize: 7,
    textAlign: 'center',
    lineHeight: '8px',
  },
  LocationEditSideSectionXL: {
    width: 10,
    height: 10,
    position: 'absolute',
    top: 124,
    right: 6,
    border: '1px solid #d9d9d9',
    color: '#337be2',
    fontSize: 6,
    textAlign: 'center',
    lineHeight: '8px',
  },
  LocationEditSideSectionBackArrow: {
    color: 'white',
    position: 'absolute',
    top: 5,
    left: 5,
    fontSize: 18,
  },
  LocationEditSideSectionFavoriteIcon: {
    color: 'white',
    position: 'absolute',
    top: 5,
    right: 5,
    fontSize: 18,
  },
  LocationEditSideSectionSaveIcon: {
    color: 'white',
    position: 'absolute',
    top: 5,
    right: 28,
    fontSize: 18,
  },
  LocationEditSideSectionMapDescription: {
    padding: '6px 6px 15px 6px',
    borderRight: 'thin solid #e7e7e7',
    borderLeft: 'thin solid #e7e7e7',
    minHeight: 7,
  },
  LocationEditSideSectionMapDescriptionButtonContainer: {
    display: 'flex',
  },
  LocationEditSideSectionMapDescriptionButton: {
    flex: 1,
    padding: 0,
    fontSize: 8,
    minWidth: 0,
    color: '#4a4d51',
    border: 'thin solid #e7e7e7',
    '&:first-of-type': {
      borderRight: 0,
      borderBottomLeftRadius: 4,
    },
    '&:last-of-type': {
      borderLeft: 0,
      borderBottomRightRadius: 4,
    },
    '& > svg': {
      fontSize: 10,
      marginRight: 5,
    },
  },
  LocationEditSideSectionSectionDayLabel: {
    textTransform: 'capitalize',
    fontSize: 'inherit',
  },
  columnView: {
    display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}));
